import ms from 'ms';

export const COUNTRY_CODES = [
  {
    name: 'Afghanistan',
    alpha: 'afg',
  },
  {
    name: 'Åland Islands',
    alpha: 'ala',
  },
  {
    name: 'Albania',
    alpha: 'alb',
  },
  {
    name: 'Algeria',
    alpha: 'dza',
  },
  {
    name: 'American Samoa',
    alpha: 'asm',
  },
  {
    name: 'Andorra',
    alpha: 'and',
  },
  {
    name: 'Angola',
    alpha: 'ago',
  },
  {
    name: 'Anguilla',
    alpha: 'aia',
  },
  {
    name: 'Antarctica',
    alpha: 'ata',
  },
  {
    name: 'Antigua and Barbuda',
    alpha: 'atg',
  },
  {
    name: 'Argentina',
    alpha: 'arg',
  },
  {
    name: 'Armenia',
    alpha: 'arm',
  },
  {
    name: 'Aruba',
    alpha: 'abw',
  },
  {
    name: 'Australia',
    alpha: 'aus',
  },
  {
    name: 'Austria',
    alpha: 'aut',
  },
  {
    name: 'Azerbaijan',
    alpha: 'aze',
  },
  {
    name: 'Bahamas',
    alpha: 'bhs',
  },
  {
    name: 'Bahrain',
    alpha: 'bhr',
  },
  {
    name: 'Bangladesh',
    alpha: 'bgd',
  },
  {
    name: 'Barbados',
    alpha: 'brb',
  },
  {
    name: 'Belarus',
    alpha: 'blr',
  },
  {
    name: 'Belgium',
    alpha: 'bel',
  },
  {
    name: 'Belize',
    alpha: 'blz',
  },
  {
    name: 'Benin',
    alpha: 'ben',
  },
  {
    name: 'Bermuda',
    alpha: 'bmu',
  },
  {
    name: 'Bhutan',
    alpha: 'btn',
  },
  {
    name: 'Bolivia (Plurinational State of)',
    alpha: 'bol',
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    alpha: 'bes',
  },
  {
    name: 'Bosnia and Herzegovina',
    alpha: 'bih',
  },
  {
    name: 'Botswana',
    alpha: 'bwa',
  },
  {
    name: 'Bouvet Island',
    alpha: 'bvt',
  },
  {
    name: 'Brazil',
    alpha: 'bra',
  },
  {
    name: 'British Indian Ocean Territory',
    alpha: 'iot',
  },
  {
    name: 'Brunei Darussalam',
    alpha: 'brn',
  },
  {
    name: 'Bulgaria',
    alpha: 'bgr',
  },
  {
    name: 'Burkina Faso',
    alpha: 'bfa',
  },
  {
    name: 'Burundi',
    alpha: 'bdi',
  },
  {
    name: 'Cabo Verde',
    alpha: 'cpv',
  },
  {
    name: 'Cambodia',
    alpha: 'khm',
  },
  {
    name: 'Cameroon',
    alpha: 'cmr',
  },
  {
    name: 'Canada',
    alpha: 'can',
  },
  {
    name: 'Cayman Islands',
    alpha: 'cym',
  },
  {
    name: 'Central African Republic',
    alpha: 'caf',
  },
  {
    name: 'Chad',
    alpha: 'tcd',
  },
  {
    name: 'Chile',
    alpha: 'chl',
  },
  {
    name: 'China',
    alpha: 'chn',
  },
  {
    name: 'Christmas Island',
    alpha: 'cxr',
  },
  {
    name: 'Cocos (Keeling) Islands',
    alpha: 'cck',
  },
  {
    name: 'Colombia',
    alpha: 'col',
  },
  {
    name: 'Comoros',
    alpha: 'com',
  },
  {
    name: 'Congo',
    alpha: 'cog',
  },
  {
    name: 'Congo, Democratic Republic of the',
    alpha: 'cod',
  },
  {
    name: 'Cook Islands',
    alpha: 'cok',
  },
  {
    name: 'Costa Rica',
    alpha: 'cri',
  },
  {
    name: "Côte d'Ivoire",
    alpha: 'civ',
  },
  {
    name: 'Croatia',
    alpha: 'hrv',
  },
  {
    name: 'Cuba',
    alpha: 'cub',
  },
  {
    name: 'Curaçao',
    alpha: 'cuw',
  },
  {
    name: 'Cyprus',
    alpha: 'cyp',
  },
  {
    name: 'Czechia',
    alpha: 'cze',
  },
  {
    name: 'Denmark',
    alpha: 'dnk',
  },
  {
    name: 'Djibouti',
    alpha: 'dji',
  },
  {
    name: 'Dominica',
    alpha: 'dma',
  },
  {
    name: 'Dominican Republic',
    alpha: 'dom',
  },
  {
    name: 'Ecuador',
    alpha: 'ecu',
  },
  {
    name: 'Egypt',
    alpha: 'egy',
  },
  {
    name: 'El Salvador',
    alpha: 'slv',
  },
  {
    name: 'Equatorial Guinea',
    alpha: 'gnq',
  },
  {
    name: 'Eritrea',
    alpha: 'eri',
  },
  {
    name: 'Estonia',
    alpha: 'est',
  },
  {
    name: 'Eswatini',
    alpha: 'swz',
  },
  {
    name: 'Ethiopia',
    alpha: 'eth',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    alpha: 'flk',
  },
  {
    name: 'Faroe Islands',
    alpha: 'fro',
  },
  {
    name: 'Fiji',
    alpha: 'fji',
  },
  {
    name: 'Finland',
    alpha: 'fin',
  },
  {
    name: 'France',
    alpha: 'fra',
  },
  {
    name: 'French Guiana',
    alpha: 'guf',
  },
  {
    name: 'French Polynesia',
    alpha: 'pyf',
  },
  {
    name: 'French Southern Territories',
    alpha: 'atf',
  },
  {
    name: 'Gabon',
    alpha: 'gab',
  },
  {
    name: 'Gambia',
    alpha: 'gmb',
  },
  {
    name: 'Georgia',
    alpha: 'geo',
  },
  {
    name: 'Germany',
    alpha: 'deu',
  },
  {
    name: 'Ghana',
    alpha: 'gha',
  },
  {
    name: 'Gibraltar',
    alpha: 'gib',
  },
  {
    name: 'Greece',
    alpha: 'grc',
  },
  {
    name: 'Greenland',
    alpha: 'grl',
  },
  {
    name: 'Grenada',
    alpha: 'grd',
  },
  {
    name: 'Guadeloupe',
    alpha: 'glp',
  },
  {
    name: 'Guam',
    alpha: 'gum',
  },
  {
    name: 'Guatemala',
    alpha: 'gtm',
  },
  {
    name: 'Guernsey',
    alpha: 'ggy',
  },
  {
    name: 'Guinea',
    alpha: 'gin',
  },
  {
    name: 'Guinea-Bissau',
    alpha: 'gnb',
  },
  {
    name: 'Guyana',
    alpha: 'guy',
  },
  {
    name: 'Haiti',
    alpha: 'hti',
  },
  {
    name: 'Heard Island and McDonald Islands',
    alpha: 'hmd',
  },
  {
    name: 'Holy See',
    alpha: 'vat',
  },
  {
    name: 'Honduras',
    alpha: 'hnd',
  },
  {
    name: 'Hong Kong',
    alpha: 'hkg',
  },
  {
    name: 'Hungary',
    alpha: 'hun',
  },
  {
    name: 'Iceland',
    alpha: 'isl',
  },
  {
    name: 'India',
    alpha: 'ind',
  },
  {
    name: 'Indonesia',
    alpha: 'idn',
  },
  {
    name: 'Iran (Islamic Republic of)',
    alpha: 'irn',
  },
  {
    name: 'Iraq',
    alpha: 'irq',
  },
  {
    name: 'Ireland',
    alpha: 'irl',
  },
  {
    name: 'Isle of Man',
    alpha: 'imn',
  },
  {
    name: 'Israel',
    alpha: 'isr',
  },
  {
    name: 'Italy',
    alpha: 'ita',
  },
  {
    name: 'Jamaica',
    alpha: 'jam',
  },
  {
    name: 'Japan',
    alpha: 'jpn',
  },
  {
    name: 'Jersey',
    alpha: 'jey',
  },
  {
    name: 'Jordan',
    alpha: 'jor',
  },
  {
    name: 'Kazakhstan',
    alpha: 'kaz',
  },
  {
    name: 'Kenya',
    alpha: 'ken',
  },
  {
    name: 'Kiribati',
    alpha: 'kir',
  },
  {
    name: "Korea (Democratic People's Republic of)",
    alpha: 'prk',
  },
  {
    name: 'Korea, Republic of',
    alpha: 'kor',
  },
  {
    name: 'Kuwait',
    alpha: 'kwt',
  },
  {
    name: 'Kyrgyzstan',
    alpha: 'kgz',
  },
  {
    name: "Lao People's Democratic Republic",
    alpha: 'lao',
  },
  {
    name: 'Latvia',
    alpha: 'lva',
  },
  {
    name: 'Lebanon',
    alpha: 'lbn',
  },
  {
    name: 'Lesotho',
    alpha: 'lso',
  },
  {
    name: 'Liberia',
    alpha: 'lbr',
  },
  {
    name: 'Libya',
    alpha: 'lby',
  },
  {
    name: 'Liechtenstein',
    alpha: 'lie',
  },
  {
    name: 'Lithuania',
    alpha: 'ltu',
  },
  {
    name: 'Luxembourg',
    alpha: 'lux',
  },
  {
    name: 'Macao',
    alpha: 'mac',
  },
  {
    name: 'Madagascar',
    alpha: 'mdg',
  },
  {
    name: 'Malawi',
    alpha: 'mwi',
  },
  {
    name: 'Malaysia',
    alpha: 'mys',
  },
  {
    name: 'Maldives',
    alpha: 'mdv',
  },
  {
    name: 'Mali',
    alpha: 'mli',
  },
  {
    name: 'Malta',
    alpha: 'mlt',
  },
  {
    name: 'Marshall Islands',
    alpha: 'mhl',
  },
  {
    name: 'Martinique',
    alpha: 'mtq',
  },
  {
    name: 'Mauritania',
    alpha: 'mrt',
  },
  {
    name: 'Mauritius',
    alpha: 'mus',
  },
  {
    name: 'Mayotte',
    alpha: 'myt',
  },
  {
    name: 'Mexico',
    alpha: 'mex',
  },
  {
    name: 'Micronesia (Federated States of)',
    alpha: 'fsm',
  },
  {
    name: 'Moldova, Republic of',
    alpha: 'mda',
  },
  {
    name: 'Monaco',
    alpha: 'mco',
  },
  {
    name: 'Mongolia',
    alpha: 'mng',
  },
  {
    name: 'Montenegro',
    alpha: 'mne',
  },
  {
    name: 'Montserrat',
    alpha: 'msr',
  },
  {
    name: 'Morocco',
    alpha: 'mar',
  },
  {
    name: 'Mozambique',
    alpha: 'moz',
  },
  {
    name: 'Myanmar',
    alpha: 'mmr',
  },
  {
    name: 'Namibia',
    alpha: 'nam',
  },
  {
    name: 'Nauru',
    alpha: 'nru',
  },
  {
    name: 'Nepal',
    alpha: 'npl',
  },
  {
    name: 'Netherlands',
    alpha: 'nld',
  },
  {
    name: 'New Caledonia',
    alpha: 'ncl',
  },
  {
    name: 'New Zealand',
    alpha: 'nzl',
  },
  {
    name: 'Nicaragua',
    alpha: 'nic',
  },
  {
    name: 'Niger',
    alpha: 'ner',
  },
  {
    name: 'Nigeria',
    alpha: 'nga',
  },
  {
    name: 'Niue',
    alpha: 'niu',
  },
  {
    name: 'Norfolk Island',
    alpha: 'nfk',
  },
  {
    name: 'North Macedonia',
    alpha: 'mkd',
  },
  {
    name: 'Northern Mariana Islands',
    alpha: 'mnp',
  },
  {
    name: 'Norway',
    alpha: 'nor',
  },
  {
    name: 'Oman',
    alpha: 'omn',
  },
  {
    name: 'Pakistan',
    alpha: 'pak',
  },
  {
    name: 'Palau',
    alpha: 'plw',
  },
  {
    name: 'Palestine, State of',
    alpha: 'pse',
  },
  {
    name: 'Panama',
    alpha: 'pan',
  },
  {
    name: 'Papua New Guinea',
    alpha: 'png',
  },
  {
    name: 'Paraguay',
    alpha: 'pry',
  },
  {
    name: 'Peru',
    alpha: 'per',
  },
  {
    name: 'Philippines',
    alpha: 'phl',
  },
  {
    name: 'Pitcairn',
    alpha: 'pcn',
  },
  {
    name: 'Poland',
    alpha: 'pol',
  },
  {
    name: 'Portugal',
    alpha: 'prt',
  },
  {
    name: 'Puerto Rico',
    alpha: 'pri',
  },
  {
    name: 'Qatar',
    alpha: 'qat',
  },
  {
    name: 'Réunion',
    alpha: 'reu',
  },
  {
    name: 'Romania',
    alpha: 'rou',
  },
  {
    name: 'Russian Federation',
    alpha: 'rus',
  },
  {
    name: 'Rwanda',
    alpha: 'rwa',
  },
  {
    name: 'Saint Barthélemy',
    alpha: 'blm',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    alpha: 'shn',
  },
  {
    name: 'Saint Kitts and Nevis',
    alpha: 'kna',
  },
  {
    name: 'Saint Lucia',
    alpha: 'lca',
  },
  {
    name: 'Saint Martin (French part)',
    alpha: 'maf',
  },
  {
    name: 'Saint Pierre and Miquelon',
    alpha: 'spm',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    alpha: 'vct',
  },
  {
    name: 'Samoa',
    alpha: 'wsm',
  },
  {
    name: 'San Marino',
    alpha: 'smr',
  },
  {
    name: 'Sao Tome and Principe',
    alpha: 'stp',
  },
  {
    name: 'Saudi Arabia',
    alpha: 'sau',
  },
  {
    name: 'Senegal',
    alpha: 'sen',
  },
  {
    name: 'Serbia',
    alpha: 'srb',
  },
  {
    name: 'Seychelles',
    alpha: 'syc',
  },
  {
    name: 'Sierra Leone',
    alpha: 'sle',
  },
  {
    name: 'Singapore',
    alpha: 'sgp',
  },
  {
    name: 'Sint Maarten (Dutch part)',
    alpha: 'sxm',
  },
  {
    name: 'Slovakia',
    alpha: 'svk',
  },
  {
    name: 'Slovenia',
    alpha: 'svn',
  },
  {
    name: 'Solomon Islands',
    alpha: 'slb',
  },
  {
    name: 'Somalia',
    alpha: 'som',
  },
  {
    name: 'South Africa',
    alpha: 'zaf',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    alpha: 'sgs',
  },
  {
    name: 'South Sudan',
    alpha: 'ssd',
  },
  {
    name: 'Spain',
    alpha: 'esp',
  },
  {
    name: 'Sri Lanka',
    alpha: 'lka',
  },
  {
    name: 'Sudan',
    alpha: 'sdn',
  },
  {
    name: 'Suriname',
    alpha: 'sur',
  },
  {
    name: 'Svalbard and Jan Mayen',
    alpha: 'sjm',
  },
  {
    name: 'Sweden',
    alpha: 'swe',
  },
  {
    name: 'Switzerland',
    alpha: 'che',
  },
  {
    name: 'Syrian Arab Republic',
    alpha: 'syr',
  },
  {
    name: 'Taiwan, Province of China',
    alpha: 'twn',
  },
  {
    name: 'Tajikistan',
    alpha: 'tjk',
  },
  {
    name: 'Tanzania, United Republic of',
    alpha: 'tza',
  },
  {
    name: 'Thailand',
    alpha: 'tha',
  },
  {
    name: 'Timor-Leste',
    alpha: 'tls',
  },
  {
    name: 'Togo',
    alpha: 'tgo',
  },
  {
    name: 'Tokelau',
    alpha: 'tkl',
  },
  {
    name: 'Tonga',
    alpha: 'ton',
  },
  {
    name: 'Trinidad and Tobago',
    alpha: 'tto',
  },
  {
    name: 'Tunisia',
    alpha: 'tun',
  },
  {
    name: 'Turkey',
    alpha: 'tur',
  },
  {
    name: 'Turkmenistan',
    alpha: 'tkm',
  },
  {
    name: 'Turks and Caicos Islands',
    alpha: 'tca',
  },
  {
    name: 'Tuvalu',
    alpha: 'tuv',
  },
  {
    name: 'Uganda',
    alpha: 'uga',
  },
  {
    name: 'Ukraine',
    alpha: 'ukr',
  },
  {
    name: 'United Arab Emirates',
    alpha: 'are',
  },
  {
    name: 'United Kingdom of Great Britain and Northern Ireland',
    alpha: 'gbr',
  },
  {
    name: 'United States of America',
    alpha: 'usa',
  },
  {
    name: 'United States Minor Outlying Islands',
    alpha: 'umi',
  },
  {
    name: 'Uruguay',
    alpha: 'ury',
  },
  {
    name: 'Uzbekistan',
    alpha: 'uzb',
  },
  {
    name: 'Vanuatu',
    alpha: 'vut',
  },
  {
    name: 'Venezuela (Bolivarian Republic of)',
    alpha: 'ven',
  },
  {
    name: 'Viet Nam',
    alpha: 'vnm',
  },
  {
    name: 'Virgin Islands (British)',
    alpha: 'vgb',
  },
  {
    name: 'Virgin Islands (U.S.)',
    alpha: 'vir',
  },
  {
    name: 'Wallis and Futuna',
    alpha: 'wlf',
  },
  {
    name: 'Western Sahara',
    alpha: 'esh',
  },
  {
    name: 'Yemen',
    alpha: 'yem',
  },
  {
    name: 'Zambia',
    alpha: 'zmb',
  },
  {
    name: 'Zimbabwe',
    alpha: 'zwe',
  },
];

export const EMBED_PERMISSIONS = [
  'access_data',
  'see_looks',
  'download_without_limit',
  'see_user_dashboards',
  'see_lookml_dashboards',
  'explore',
];

// time before trying to get a new Looker token
// Looker tokens expire every 1 hour, so this should refresh 5 minutes before then
export const USER_AUTH_TOKEN_VALIDITY = ms('55m'); //in minutes

export const MEASURE_TO_COLORS_MAPPING = {
  // no more used
  '% Change': { start1: '#219653', end1: '#219653', start2: '#6FCF97', end2: '#6FCF97' },
  Clicks: { start1: '#FED840', end1: '#FFB351', start2: '#FFEFB3', end2: '#FFE1B9' },
  Position: { start1: '#FF9518', end1: '#FF6200', start2: '#FFD5A3', end2: '#FFC099' },
  CTR: { start1: '#5CD7ED', end1: '#19AADE', start2: '#BEEFF8', end2: '#A3DDF2' },
  Impressions: { start1: '#A500D8', end1: '#490094', start2: '#DB99EF', end2: '#B699D4' },
  'Market Share': { start1: '#FF53CF', end1: '#BB00BF', start2: '#FFBAEC', end2: '#E499E5' },
  Visitors: { start1: '#3CDDA3', end1: '#1E826F', start2: '#B2E3DA', end2: '#B7CFCA' },
  Conversions: { start1: '#DDBA3C', end1: '#B29C4B', start2: '#E3D9B6', end2: '#D6D0B7' },

  'Unique Pages': { start1: '#FED840', end1: '#FFB351', start2: '#FFEFB3', end2: '#FFE1B9' },
  'Unique Keywords': { start1: '#FF9518', end1: '#FF6200', start2: '#FFD5A3', end2: '#FFC099' },
  'Performance Score': { start1: '#FF9518', end1: '#FF6200', start2: '#FFD5A3', end2: '#FFC099' },
  'Accessibility Score': { start1: '#A500D8', end1: '#490094', start2: '#DB99EF', end2: '#B699D4' },
  'Best Practices Score': { start1: '#5CD7ED', end1: '#19AADE', start2: '#BEEFF8', end2: '#A3DDF2' },
  'SEO Compliance Score': { start1: '#E76B37', end1: '#5F2106', start2: '#E5C0B0', end2: '#BDAAA2' },
  'Speed Index': { start1: '#DDBA3C', end1: '#B29C4B', start2: '#E3D9B6', end2: '#D6D0B7' },
  'First Contentful Paint (FCP)': { start1: '#FED840', end1: '#FFB351', start2: '#FFEFB3', end2: '#FFE1B9' },
  'Cumulative Layout Shift (CLS)': { start1: '#FF9518', end1: '#FF6200', start2: '#FFD5A3', end2: '#FFC099' },
  'Time to Interactive (TTI)': { start1: '#5CD7ED', end1: '#19AADE', start2: '#BEEFF8', end2: '#A3DDF2' },
  'Time to First Byte (TTFB)': { start1: '#A500D8', end1: '#490094', start2: '#DB99EF', end2: '#B699D4' },
  'Largest Contentful Paint (LCP)': { start1: '#FF53CF', end1: '#BB00BF', start2: '#FFBAEC', end2: '#E499E5' },
  'Interaction to Next Paint (INP)': { start1: '#FF53CF', end1: '#BB00BF', start2: '#FFBAEC', end2: '#E499E5' },
  Sessions: { start1: '#FED840', end1: '#FFB351', start2: '#FFEFB3', end2: '#FFE1B9' },
  'Conversion Rate': { start1: '#FF9518', end1: '#FF6200', start2: '#FFD5A3', end2: '#FFC099' },
  'Total Value': { start1: '#5CD7ED', end1: '#19AADE', start2: '#BEEFF8', end2: '#A3DDF2' },
  'Bounce Rate': { start1: '#A500D8', end1: '#490094', start2: '#DB99EF', end2: '#B699D4' },
  'Average Session Duration': { start1: '#FF53CF', end1: '#BB00BF', start2: '#FFBAEC', end2: '#E499E5' },
  'Unique Pageviews': { start1: '#3CDDA3', end1: '#1E826F', start2: '#B2E3DA', end2: '#B7CFCA' },
  'Average Time on Page': { start1: '#DDBA3C', end1: '#B29C4B', start2: '#E3D9B6', end2: '#D6D0B7' },
  'Total Events': { start1: '#FED840', end1: '#FFB351', start2: '#FFEFB3', end2: '#FFE1B9' },
  'Average Events': { start1: '#FF9518', end1: '#FF6200', start2: '#FFD5A3', end2: '#FFC099' },
  'Total Cost': { start1: '#A500D8', end1: '#490094', start2: '#DB99EF', end2: '#B699D4' },
  'Cost Per Clicks': { start1: '#FED840', end1: '#FFB351', start2: '#FFEFB3', end2: '#FFE1B9' },
  'Cost Per Conversions': { start1: '#DDBA3C', end1: '#B29C4B', start2: '#E3D9B6', end2: '#D6D0B7' },
};

export const GOOGLE_FETCH_FAVICON_API = 'https://www.google.com/s2/favicons';

const splitedStrArray = process.env.NEXT_PUBLIC_LOOKER_API_URL ? process.env.NEXT_PUBLIC_LOOKER_API_URL.split(':') : [];
export const LOOKER_INSTANCE_URL = [splitedStrArray[0], splitedStrArray[1]].join(':');

export const MARKET_SHARE_FILL_COLOR_MEASURE_ONE = { start: 'rgba(132, 93, 81, 0.2)', end: 'rgba(132, 93, 81, 0.2)' };
export const MARKET_SHARE_FILL_COLOR_MEASURE_TWO = { start: 'rgba(132, 93, 81, 0.2)', end: 'rgba(132, 93, 81, 0.2)' };

export const LOOKER_ROLE_IDS = {
  development: [3, 4],
  production: [7],
};

export const LOOKER_SCHEMA_SUFFIX_ATTR_ID = {
  development: 28,
  production: 14,
};

export const LOOKER_CONTENT_AI_USERS_GRP = {
  development: 59,
  production: 257,
};

export const CONTENT_AI_USER_TYPE = 'CONTENT_AI';

export const EXPANDED_VIEW_TYPE = {
  TOP_OPPORTUNITY: 'TOP_OPPORTUNITY',
  POTENTIAL_OPPORTUNITY: 'POTENTIAL_OPPORTUNITY',
};

export const sandboxExcludeDomain = [
  'forhers.com',
  'forhims.com',
  'www.forhims.com',
  'housing.com',
  'www.housing.com',
  'hostinger.com',
  'www.hostinger.com',
  'www.gonoise.com',
  'gonoise.com',
  'www.flipkart.com',
  'www.crownwoodcharters.co.uk',
  'crownwoodcharters.co.uk',
  'mcafee.com',
  'www.mcafee.com',
  'nobroker.in',
  'www.nobroker.in',
  'flipkart.com',
];
export const htmlPreviewExcludeScriptDomain = ['www.richardmille.com', 'richardmille.com'];
export const GROWTH_TRENDS_ROUTE = '/app/trends/growth-trends';
export const MARKET_SHARE_ROUTE = '/app/trends/competitive-trends';
export const ADHOC_ANALYSIS_PARENT_ROUTE = '/app/adhoc-analysis';
export const RANKING_FACTORS_ROUTE = '/app/ranking-factors/ranking-factors-summary';
export const ADHOC_ANALYSIS_ROUTE = '/app/adhoc-analysis/all-boards/explore';

export const PREFFERED_COLORS_FOR_LINE_GRAPHS = [
  '#8A3FFC',
  '#E590B7',
  '#FFC2C2',
  '#FF7800',
  '#BA4E00',
  '#33B1FF',
  '#007D79',
  '#6686BF',
  '#00DBD8',
  '#D4BBFF',
];

export const COLORS = [
  '#63b598',
  '#ce7d78',
  '#ea9e70',
  '#a48a9e',
  '#648177',
  '#0d5ac1',
  '#f205e6',
  '#1c0365',
  '#4ca2f9',
  '#6119d0',
  '#79806e',
  '#cd2f00',
  '#d2737d',
  '#c0a43c',
  '#f2510e',
  '#651be6',
  '#0cd36d',
  '#e1cf3b',
  '#9348af',
  '#c5a4fb',
  '#996635',
  '#b11573',
  '#41d158',
  '#ea24a3',
  '#2f3f94',
  '#2f7b99',
  '#da967d',
  '#34891f',
  '#ca4751',
  '#7e50a8',
  '#c4d647',
  '#11dec1',
  '#289812',
  '#566ca0',
  '#d00043',
  '#30cc49',
  '#935b6d',
  '#916988',
  '#513d98',
  '#aead3a',
  '#9e6d71',
  '#4b5bdc',
  '#cb5bea',
  '#228916',
  '#ac3e1b',
  '#df514a',
  '#539397',
  '#880977',
  '#f697c1',
  '#ba96ce',
  '#679c9d',
  '#c6c42c',
  '#5d2c52',
  '#48b41b',
  '#5be4f0',
  '#57c4d8',
  '#be608b',
  '#96b00c',
  '#088baf',
  '#dc1c06',
  '#f158bf',
  '#ee91e3',
  '#5426e0',
  '#4834d0',
  '#802234',
  '#ff065',
  '#6749e8',
  '#0971f0',
  '#8fb413',
  '#b2b4f0',
  '#c3c89d',
  '#c9a941',
  '#fb21a3',
  '#51aed9',
  '#21538e',
  '#89d534',
  '#d36647',
  '#e4ac44',
  '#7fb411',
  '#0023b8',
  '#3b8c2a',
  '#986b53',
  '#f50422',
  '#983f7a',
  '#79352c',
  '#c79ed2',
  '#e33e52',
  '#b2be57',
  '#996c48',
  '#9ab9b7',
  '#1bb699',
  '#6b2e5f',
  '#21538e',
  '#d36647',
  '#521250',
  '#fa06ec',
  '#06e052',
  '#e3a481',
  '#0eb621',
  '#fc458e',
  '#aa226d',
  '#792ed8',
  '#73872a',
  '#520d3a',
  '#a5b3d9',
  '#7d1d85',
  '#c4fd57',
  '#f1ae16',
  '#ef6e3c',
  '#1dc18',
  '#dd93fd',
  '#3f8473',
  '#d02e29',
  '#9cb64a',
  '#421f79',
  '#7a3d93',
  '#635f6d',
  '#9b5c2a',
  '#0f5997',
  '#0ec0ff',
  '#409188',
  '#911e20',
  '#1350ce',
  '#cb2582',
  '#ce00be',
  '#8a96c6',
  '#32d5d6',
  '#608572',
  '#c79bc2',
  '#77772a',
  '#6995ba',
  '#77ecca',
  '#fc6b57',
  '#f07815',
  '#8fd883',
  '#060e27',
  '#96e591',
  '#21d52e',
  '#b47162',
  '#4f0f6f',
  '#947002',
  '#bde052',
  '#e08c56',
  '#a84a8f',
  '#911e7e',
  '#3f16d9',
  '#0f525f',
  '#ac7c0a',
  '#b4c086',
  '#c9d730',
  '#3d6751',
  '#fb4c03',
  '#640fc1',
  '#d3493a',
  '#88aa0b',
  '#406df9',
  '#615af0',
  '#2a3434',
  '#4a543f',
  '#79bca0',
  '#a8b8d4',
  '#3e464c',
  '#7ad236',
  '#7260d8',
  '#1deaa7',
  '#06f43a',
  '#823c59',
  '#e3d94c',
  '#f53b2a',
  '#b46238',
  '#a82b89',
  '#1a8011',
  '#436a9f',
  '#1a806a',
  '#4cf09d',
  '#c188a2',
  '#67eb4b',
  '#b308d3',
  '#fc7e41',
  '#af3101',
  '#71b1f4',
  '#a2f8a5',
  '#e23dd0',
  '#d3486d',
  '#474893',
  '#3cec35',
  '#1c65cb',
  '#5d1d0c',
  '#2d7d2a',
  '#ff3420',
  '#5cdd87',
  '#a259a4',
  '#8798a4',
  '#d7790f',
  '#b2c24f',
  '#de73c2',
  '#d70a9c',
  '#25b67',
  '#88e9b8',
  '#c2b0e2',
  '#86e98f',
  '#ae90e2',
  '#1a806b',
  '#436a9e',
  '#f812b3',
  '#b17fc9',
  '#8d6c2f',
  '#d3277a',
  '#2ca1ae',
  '#9685eb',
  '#dba2e6',
  '#76fc1b',
  '#608fa4',
  '#20f6ba',
  '#07d7f6',
  '#dce77a',
];

export const RESOLUTION_ENTITY_TYPE = {
  TOP_OPPORTUNITY: 'top-opportunity',
  TOP_TRENDS: 'top-trend',
  USABILITY_RECOMMENDATIONS: 'usability-recommendation',
  CONTENT_RECOMMENDATIONS: 'content-recommendation',
  CNP: 'new-page',
};

export const SITE_USABILITY_SUMMARY_METRIC = 'Site Usability Summary';

export const INDEXATION_METRIC = ['percent_pages_indexed_M', 'total_pages_indexed_M'];

export const SITE_USABILITY_EXPLORE = 'site_usability_recommendation_v2';

export const QDS_MARKET_SHARE_MODEL = 'qds_market_share';

export const SITE_USABILITY_METRICS = [
  'performance score',
  'accessibility score',
  'best practices score',
  'seo compliance score',
  'site usability summary',
];

export const SITE_REPORT_SUMMARY = [
  'search engine performance',
  'visitors summary',
  'conversion summary',
  'google ads summary',
  'site usability summary',
  'site speed summary',
];

export const SITE_USABILIT_AUDIT_LKP_EXPLORE = 'site_usability_audit_lkp';
export const CONTENT_RECOMMENDATION_EXPLORE = 'content_recommendations';

export const CONTENT_RECOMMENDATION_PAGE = 'content_recommendation_page';

export const INCLUDE_NONE_METRIC_DEFAULT = ['search engine performance', 'google ads summary'];
export const USABILITY_SCORE_METRIC_VALUES = ['performance', 'AccessibilityScore', 'BestPracticesScore', 'SEOScore'];

export const FEATURED_HTML_EDITABLE_COLUMNS = ['CONTENT', 'CURRENT', 'ALT TEXT', 'TEXT'];

export const CR_INSIGHT_KEYWORDS_EXPLORE = 'cr_insight_keywords';

export const performanceScoreRanges = {
  // 'First CPU Idle': { min:0, max: 0 },
  // 'First Contentful Paint (FCP)': { min:0, max: 0 },
  // 'First Meaningful Paint (FMP)': { min:0, max: 0 },
  'Largest Contentful Paint (LCP)': { min: '2.5 sec', max: '4.0 sec' },
  'Interaction to Next Paint (INP)': { min: '2.5 sec', max: '4.0 sec' },
  'Max Potential First Input Delay (FID)': { min: '100 ms', max: '300 ms' },
  // 'Speed Index': { min:0, max: 0 },
  // 'Time to Interactive (TTI)': { min:0, max: 0 },
  'Cumulative Layout Shift (CLS)': { min: '0.1', max: '0.25' },
};

export const PERFORMANCE_METRICS = {
  'First Contentful Paint (FCP)': 'FCP',
  'Largest Contentful Paint (LCP)': 'LCP',
  'Cumulative Layout Shift (CLS)': 'CLS',
  'Interaction to Next Paint (INP)': 'INP',
};

export const PAGE_JOB_STATUS = {
  NEW: 'new',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'complete',
};

export const TOPICS_SUGGEST_NEW_COPY_TAGS = [
  { text: 'Select Tag', value: null },
  { text: 'H1', value: 'H1' },
  { text: 'TITLE', value: 'Title' },
  { text: 'META DESCRIPTION', value: 'Meta Description' },
  { text: 'H2', value: 'H2' },
  { text: 'H3', value: 'H3' },
  { text: 'H4', value: 'H4' },
  { text: 'H5', value: 'H5' },
  { text: 'H6', value: 'H6' },
  { text: 'P', value: 'p' },
  { text: 'PRE', value: 'pre' },
  { text: 'LABEL', value: 'label' },
  { text: 'LI', value: 'li' },
  { text: 'SPAN', value: 'span' },
];

export const FILTER_TYPE = {
  device: { value: '{value}', children: 'Is Equal to' },
  intent: { value: '{value}', children: 'Is Equal to' },
  country: { value: '{value}', children: 'Is Equal to' },
  sources: { value: '{value}', children: 'Is Equal to' },
  category: { value: '{value}', children: 'Is Equal to' },
  pages: { value: '{value}', children: 'Is Equal to' },
  queries: { value: '{value}', children: 'Is Equal to' },
  distinct_search_type: { value: '{value}', children: 'Is Equal to' },
  goals_concat: { value: '{value}', children: 'Is Equal to' },
  domain: { value: '{value}', children: 'Is Equal to' },
  language: { value: '{value}', children: 'Is Equal to' },
  adgroup_name: { value: '{value}', children: 'Is Equal to' },
  campaign_name: { value: '{value}', children: 'Is Equal to' },
  campaign_type: { value: '{value}', children: 'Is Equal to' },
  page_experience: { value: '{value}', children: 'Is Equal to' },
  keyword_country: { value: '{value}', children: 'Is Equal to' },
  keyword_state: { value: '{value}', children: 'Is Equal to' },
  keyword_city: { value: '{value}', children: 'Is Equal to' },
  page_country: { value: '{value}', children: 'Is Equal to' },
  page_state: { value: '{value}', children: 'Is Equal to' },
  page_city: { value: '{value}', children: 'Is Equal to' },
};
export const TOPIC_BODY_TAGS = ['P', 'PRE', 'LI', 'LABEL', 'SPAN'];

export const POTENTIAL_KEYWORD_CLUSTER_TYPE = {
  'domain-level-gap': 'New For Domain',
  'page-level-gap': 'New For Page',
  manual: 'Manual',
};

export const SUBSCRIPTION_STATUS = {
  SUBSCRIPTION_CREATED: 'subscription_created',
  SUBSCRIPTION_TRIAL_END_REMINDER: 'subscription_trial_end_reminder',
  SUBSCRIPTION_ACTIVATED: 'subscription_activated',
  SUBSCRIPTION_CANCELLED: 'subscription_cancelled',
  SUBSCRIPTION_PAUSED: 'subscription_paused',
  SUBSCRIPTION_RESUMED: 'subscription_resumed',
  SUBSCRIPTION_STARTED: 'subscription_started',
  SUBSCRIPTION_REACTIVATED: 'subscription_reactivated',
};

export const chargebeeDayPassPlans = {
  dev: {
    // DAY_PASS: 'Day-Pass-2-USD',
    DAY_PASS: 'Day-Pass-Lite-20-Credits-USD',
    DAY_PASS_LITE: 'Day-Pass-Lite-20-Credits-USD', // not used in ui for now
  },
  prod: {
    // DAY_PASS: 'Quattr-Tools-Day-Pass-USD',
    DAY_PASS: 'Day-Pass-Lite-20-Credits-USD',
    DAY_PASS_LITE: 'Day-Pass-Lite-20-Credits-USD', // not used in ui for now
  },
};

export const UPGRADE_PLANS_CONFIG = [
  {
    type: 'Starter',
    currency: '$',
    monthlyAmount: 3.99,
    yearlyAmount: 39,
    creditsPerDay: 15,
    access: 'AI Tools access',
    validTill: '24hrs',
    noOfUser: 1,
    addCreditWith: 3.99,
    isAddMore: false,
  },
  {
    type: 'Lite',
    currency: '$',
    monthlyAmount: 9.99,
    yearlyAmount: 99,
    creditsPerDay: 40,
    access: 'AI Tools access',
    validTill: '24hrs',
    noOfUser: 1,
    addCreditWith: 3.99,
    isAddMore: false,
  },
  {
    type: 'Pro',
    currency: '$',
    monthlyAmount: 29.99,
    yearlyAmount: 299,
    creditsPerDay: 150,
    access: 'AI Tools access',
    validTill: '24hrs',
    noOfUser: 1,
    addCreditWith: 2.99,
    isAddMore: false,
  },
  // {
  //   type: 'Ultra',
  //   currency: '$',
  //   monthlyAmount: 49.99,
  //   yearlyAmount: 499,
  //   creditsPerDay: 250,
  //   access: 'AI Tools access',
  //   validTill: '24hrs',
  //   noOfUser: 1,
  //   addCreditWith: 2.99,
  //   isAddMore: true,
  // },
];

export const ISPDomains = [
  'comcast.net',
  'verizon.net',
  'att.net',
  'charter.net',
  'cox.net',
  'frontier.com',
  'centurylink.net',
  'earthlink.net',
  'rogers.com',
  'bell.ca',
  'shaw.ca',
  'telus.net',
  'btinternet.com',
  'virginmedia.com',
  'sky.com',
  'talktalk.net',
  'bigpond.com',
  'optusnet.com.au',
  'iinet.net.au',
  'tpg.com.au',
  'airtelbroadband.in',
  'reliancebroadband.co.in',
  'bsnl.in',
  'hathway.com',
  'aol.com',
  'gmail.com',
  'yahoo.com',
];

// Create 200 distinctive two-word combinations for coursera that are unconventional and unique, suitable for labeling internal modules in a new linking module UI. The names should avoid generic or overused terms and don't need to suggest any relationship to linking functionality. Provide the output in JSON format as a string array, with no other content except the JSON array.
export const TEMP_IL_UNIQUE_NAME = [
  'Azure Mirage',
  'Velvet Chimera',
  'Nebula Bloom',
  'Crimson Zephyr',
  'Ivory Quasar',
  'Obsidian Echo',
  'Cobalt Lattice',
  'Prism Canopy',
  'Shadow Tapestry',
  'Amber Wisp',
  'Eclipse Haven',
  'Sable Cascade',
  'Plum Whisper',
  'Graphite Ember',
  'Verdant Veil',
  'Lunar Fragment',
  'Silicon Drift',
  'Nimbus Mosaic',
  'Ochre Labyrinth',
  'Coral Shard',
  'Banyan Phantasm',
  'Scarlet Mirth',
  'Crystal Halo',
  'Cerulean Riddle',
  'Maple Gleam',
  'Aubergine Horizon',
  'Pixel Frost',
  'Tulip Zenith',
  'Raven Echo',
  'Echo Lattice',
  'Velvet Paradox',
  'Mystic Nova',
  'Frosted Glyph',
  'Opal Conundrum',
  'Nimbus Flare',
  'Solar Canopy',
  'Jasper Canvas',
  'Ivory Starlight',
  'Amber Grove',
  'Sapphire Shade',
  'Lime Quasar',
  'Floral Ember',
  'Pineapple Drift',
  'Crimson Murmur',
  'Nimbus Echo',
  'Clover Cascade',
  'Zephyr Maze',
  'Jargon Bloom',
  'Cinder Whisper',
  'Octane Fragment',
  'Mirthful Orbit',
  'Copper Tone',
  'Rustic Shadow',
  'Carbon Muse',
  'Verdant Maze',
  'Shadow Haze',
  'Scarlet Codex',
  'Ivory Reverie',
  'Azure Wisp',
  'Velvet Apex',
  'Cyan Horizon',
  'Maple Vortex',
  'Crimson Zephyr',
  'Salmon Flicker',
  'Eclipse Wisp',
  'Silken Echo',
  'Graphite Slice',
  'Coral Patch',
  'Magma Myriad',
  'Abyssal Drift',
  'Fuchsia Tapestry',
  'Prism Riddle',
  'Lunar Tango',
  'Amber Glyph',
  'Sable Canvas',
  'Nimbus Frost',
  'Zephyr Riddle',
  'Cerulean Glow',
  'Jade Serenade',
  'Gilded Echo',
  'Scarlet Phantom',
  'Obsidian Bloom',
  'Topaz Glimmer',
  'Solar Fragment',
  'Echo Reverie',
  'Frosted Gleam',
  'Cinder Wisp',
  'Verdant Quirk',
  'Nebula Tone',
  'Tulip Drift',
  'Velvet Lattice',
  'Aubergine Conundrum',
  'Shadow Patch',
  'Crimson Glyph',
  'Lime Echo',
  'Opal Starlight',
  'Amber Maze',
  'Pixel Lattice',
  'Azure Canopy',
  'Mosaic Whisper',
  'Cerulean Phantasm',
  'Sable Frost',
  'Graphite Reverie',
  'Nimbus Veil',
  'Raven Bloom',
  'Jargon Halo',
  'Burgundy Lattice',
  'Cobalt Tapestry',
  'Ivory Labyrinth',
  'Sapphire Drift',
  'Scarlet Mirth',
  'Octane Echo',
  'Abyssal Glyph',
  'Plum Whisper',
  'Prism Wisp',
  'Velvet Echo',
  'Lunar Mirth',
  'Tulip Bloom',
  'Rustic Echo',
  'Nimbus Starlight',
  'Eclipse Shadow',
  'Clover Fragment',
  'Amber Frost',
  'Azure Phantom',
  'Nebula Slice',
  'Solar Codex',
  'Zephyr Fragment',
  'Jasper Bloom',
  'Crystal Canopy',
  'Mirthful Drift',
  'Aubergine Veil',
  'Cinder Quasar',
  'Amber Tone',
  'Fuchsia Reverie',
  'Coral Apex',
  'Nimbus Muse',
  'Echo Canvas',
  'Zephyr Wisp',
  'Sable Glyph',
  'Opal Drift',
  'Tulip Murmur',
  'Magma Lattice',
  'Frosted Gleam',
  'Velvet Cascade',
  'Raven Myriad',
  'Graphite Echo',
  'Scarlet Bloom',
  'Lime Shadow',
  'Plum Riddle',
  'Crystal Fragment',
  'Abyssal Zephyr',
  'Nebula Veil',
  'Nimbus Apex',
  'Prism Starlight',
  'Sapphire Labyrinth',
  'Cerulean Patch',
  'Rustic Blossom',
  'Mirthful Echo',
  'Pixel Gleam',
  'Burgundy Muse',
  'Shadow Cascade',
  'Amber Reverie',
  'Crimson Wisp',
  'Obsidian Echo',
  'Lunar Bloom',
  'Sable Shade',
  'Scarlet Veil',
  'Jade Echo',
  'Frosted Fragment',
  'Crystal Gleam',
  'Clover Riddle',
  'Tulip Whisper',
  'Graphite Canopy',
  'Nimbus Shadow',
  'Solar Echo',
  'Velvet Quasar',
  'Ivory Bloom',
  'Nebula Frost',
  'Plum Drift',
  'Prism Muse',
  'Aubergine Whisper',
  'Raven Gleam',
  'Amber Murmur',
  'Sable Fragment',
  'Crimson Cascade',
  'Echo Blossom',
  'Frosted Apex',
  'Cinder Veil',
  'Lunar Reverie',
  'Tulip Echo',
  'Azure Whisper',
  'Cerulean Apex',
  'Mosaic Echo',
  'Ivory Lattice',
  'Scarlet Muse',
];

export const API_STATUS = {
  NOT_START: '',
  START: 'START',
  RUNNING: 'RUNNING',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
};

export const PAGE_CONTENT_SOURCE = {
  GIGA_ACCEPT: 'GIGA_ACCEPT',
  GIGA_DRAFT: 'GIGA_DRAFT',
  ORIGINAL_PAGE_CONTENT: 'ORIGINAL_PAGE_CONTENT',
};

export const GIGA_IMPROVE_HANDLER_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  IN_PROGRESS: 'in-progress',
};

export const GIGA_CTA_TOOLTIP = `Let Quattr’s AI agent go through the generated insights and generate a revised version of your page in one click.`;
